/** Shared filter constants for Margin order history pages. */

export const MARGIN_ACCOUNT_TYPE_OPTIONS = [
  { value: "isolated", label: "Isolated Margin" },
  { value: "cross",    label: "Cross Margin" },
];

export const MARGIN_SUB_TABS = [
  { label: "Open Orders",       to: "/user_profile/orders/margin_orders" },
  { label: "Order History",     to: "/user_profile/orders/margin_order_history" },
  { label: "Position History",  to: "/user_profile/orders/margin_position_history" },
  { label: "Trade History",     to: "/user_profile/orders/margin_trade_history" },
  { label: "Transfer History",  to: "/user_profile/orders/margin_transfer_history" },
  { label: "Borrowing History", to: "/user_profile/orders/margin_borrowing_history" },
];

export const MARGIN_POSITION_SIDE_OPTIONS = [
  { value: "all",   label: "All" },
  { value: "LONG",  label: "Long" },
  { value: "SHORT", label: "Short" },
];

export const MARGIN_TYPE_OPTIONS = [
  { value: "all",          label: "All" },
  { value: "limit",        label: "Limit" },
  { value: "market",       label: "Market" },
  { value: "stop_limit",   label: "Stop Limit" },
  { value: "stop_market",  label: "Stop Market" },
];

export const MARGIN_SIDE_OPTIONS = [
  { value: "all",  label: "All" },
  { value: "buy",  label: "Buy" },
  { value: "sell", label: "Sell" },
];

export const MARGIN_STATUS_OPTIONS = [
  { value: "all",               label: "All" },
  { value: "PARTIALLY_FILLED",  label: "Partially Filled" },
  { value: "FILLED",            label: "Filled" },
  { value: "CANCELLED",         label: "Cancelled" },
  { value: "REJECTED",          label: "Rejected" },
  { value: "EXPIRED",           label: "Expired" },
];

export const BORROWING_TYPE_OPTIONS = [
  { value: "borrow",   label: "Borrow" },
  { value: "repay",    label: "Repay" },
  { value: "interest", label: "Interest" },
];

/** Build pair dropdown options from marginAccounts API response. */
export function buildMarginPairOptions(accounts) {
  const opts = (Array.isArray(accounts) ? accounts : [])
    .filter((a) => a.base_asset && a.quote_asset)
    .map((a) => ({
      value: `${a.base_asset}_${a.quote_asset}`.toLowerCase(),
      label: `${a.base_asset}/${a.quote_asset}`,
    }));
  opts.sort((a, b) => a.label.localeCompare(b.label));
  return [{ value: "all", label: "All" }, ...opts];
}
